import type { UndecoratedFile } from '@witmetrics/utils';
import { FILE_TYPES } from '@witmetrics/utils/constants';

export const classes = {
  message: 'px-4 text-lg text-grey-7 dark:text-mauve-2 py-8 text-center',
  toggleBlock: 'shrink-0',
  label: 'ml-2',
};

export function getFileTypes(files: UndecoratedFile[]) {
  const fileTypeIds = files.map(getFileTypeId);
  // Maintains consistent order of fileTypes
  return Object.values(FILE_TYPES).filter((f) => fileTypeIds.includes(f.id));
}

function getFileTypeId(file: UndecoratedFile) {
  return file.fileTypeId || FILE_TYPES.EXTRA.id;
}
